import { getHydraTokens, matchStateFromLocalStorage } from "./helpers/auth.helper.js";
import { CONSTANTS } from "./helpers/constants.js";
import { getTokenFromStorage, removeLocalStorageItem, setLocalStorageItem } from "./helpers/token.service.js";

//#region src/get-auth-tokens-from-code.ts
/**
* The code exchange for this page, in progress or complete.
* An authorization code is single use. If the same code is exchanged twice,
* Ory revokes the tokens from the first exchange too, so every caller with
* the same code shares one request.
*
* @see MYPT-1122
*/
let activeCodeExchange = null;
/** Reset the active code exchange. Exported for tests. */
const resetActiveCodeExchange = () => {
	activeCodeExchange = null;
};
const exchangeCode = async ({ responseCode, base64StateInUrl = "", ssoClientId, redirectUri, ssoTokenApi }) => {
	if (responseCode) {
		const matchStateResponse = matchStateFromLocalStorage(base64StateInUrl);
		if (matchStateResponse.isValid) {
			const stateKey = matchStateResponse.decodedState?.state ?? CONSTANTS.csrfProtectionState;
			const codeVerifierKey = `${stateKey}${CONSTANTS.pkceCodeVerifierPrefix}`;
			const codeVerifier = getTokenFromStorage(codeVerifierKey) ?? "";
			removeLocalStorageItem(stateKey);
			removeLocalStorageItem(codeVerifierKey);
			const responseJson = await (await getHydraTokens(responseCode, ssoClientId, ssoTokenApi, false, codeVerifier, redirectUri)).json();
			if (responseJson.access_token && responseJson.refresh_token) {
				const tokens = {
					accessToken: responseJson.access_token,
					refreshToken: responseJson.refresh_token,
					exp: responseJson.expires_in
				};
				setLocalStorageItem(CONSTANTS.tokenKey, JSON.stringify(tokens));
				return { nextUrl: matchStateResponse.decodedState?.currentUrl };
			} else if (responseJson.error) return {
				error: responseJson.error,
				errorDescription: responseJson.error_description
			};
			return { error: "access or refresh token is missing" };
		}
		if (matchStateResponse.isMissing) return { error: "Login state is missing or was already used" };
		return { error: "CSRF state mismatch during login" };
	}
	return { error: "response code is missing to get the tokens" };
};
const getAuthTokensFromCode = (props) => {
	if (activeCodeExchange?.code === props.responseCode) return activeCodeExchange.promise;
	const promise = exchangeCode(props);
	activeCodeExchange = {
		code: props.responseCode,
		promise
	};
	return promise;
};

//#endregion
export { getAuthTokensFromCode, resetActiveCodeExchange };